import { Fragment } from 'react'
import { Menu, Transition } from '@headlessui/react'
import 'lucide-react';
import { cn } from '../../lib/utils'

export function DropdownMenu({ children }) {
    return <Menu as="div" className="relative inline-block text-left">{children}</Menu>
}

export function DropdownMenuTrigger({ children, asChild, className, ...props }) {
    return (
        <Menu.Button as={asChild ? 'div' : 'button'} className={className} {...props}>
            {children}
        </Menu.Button>
    )
}

export function DropdownMenuContent({ children, className, align = 'left', ...props }) {
    const alignmentClasses = {
        left: 'left-0 origin-top-left',
        right: 'right-0 origin-top-right',
    }

    return (
        <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
        >
            <Menu.Items
                className={cn(
                    'absolute top-full z-[60] mt-1 rounded-xl bg-white shadow-[0_4px_20px_-4px_rgba(0,0,0,0.1)] ring-1 ring-black ring-opacity-5 focus:outline-none',
                    'dark:bg-[#18181b] dark:ring-white/10 dark:shadow-2xl',
                    alignmentClasses[align],
                    className
                )}
                {...props}
            >
                <div className="py-1">{children}</div>
            </Menu.Items>
        </Transition>
    )
}

export function DropdownMenuItem({ children, className, onClick, ...props }) {
    return (
        <Menu.Item>
            {({ active }) => (
                <button
                    className={cn(
                        'flex items-center w-full text-left px-4 py-2 text-sm font-medium text-gray-700 whitespace-nowrap transition-colors',
                        active && 'bg-gray-100 dark:bg-white/10 text-gray-900 dark:text-white',
                        'dark:text-gray-300 dark:hover:bg-white/10',
                        className
                    )}
                    onClick={onClick}
                    {...props}
                >
                    {children}
                </button>
            )}
        </Menu.Item>
    )
}

export function DropdownMenuLabel({ children, className, ...props }) {
    return (
        <div className={cn('px-4 py-2 text-sm font-semibold text-gray-900 dark:text-white', className)} {...props}>
            {children}
        </div>
    )
}

export function DropdownMenuSeparator({ className, ...props }) {
    return (
        <div className={cn('h-px my-1 bg-gray-200 dark:bg-white/10', className)} {...props} />
    )
}